module.exports = __webpack_public_path__ + "img/78000.edb62453.jpg";